/**
 * Collection Gallery Slider
 * Slider de galeria de coleção usando Swiper nativo do tema
 */
if (!customElements.get('collection-gallery-slider')) {
  class CollectionGallerySlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.initSlider();
    }

    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }

    initSlider() {
      const container = this.querySelector('.swiper-container');
      
      if (!container || typeof MinimogLibs === 'undefined' || !MinimogLibs.Swiper) {
        console.warn('Collection Gallery Slider: Swiper não disponível');
        return;
      }

      // Configurações de autoplay
      const enableAutoplay = this.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 4;
      
      // Conta os slides
      const slides = this.querySelectorAll('.swiper-slide');
      const slideCount = slides.length;

      this.slider = new MinimogLibs.Swiper(container, {
        slidesPerView: 1.5,
        spaceBetween: 12,
        loop: false,
        rewind: true, // Volta ao início quando chega ao final
        grabCursor: true,
        watchOverflow: true, // Desativa quando não há slides suficientes
        autoplay: enableAutoplay
          ? {
              delay: autoplaySpeed * 1000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
              stopOnLastSlide: false // Não para no último, usa rewind
            }
          : false,
        breakpoints: {
          480: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 24
          },
          1280: {
            slidesPerView: 5,
            spaceBetween: 24
          }
        },
        on: {
          init: (swiper) => {
            this.setAttribute('data-initialized', 'true');
            
            // Se não precisa de scroll, desativa o grab cursor
            if (swiper.isLocked) {
              this.classList.add('no-scroll');
            }
          }
        }
      });
    }
  }

  customElements.define('collection-gallery-slider', CollectionGallerySlider);
}
